const MOBILE_MENU_SELECTOR = '.dd-mobile-menu';
const TEMPLATE_CONTAINER_SELECTOR = '.dd-mega-menu-templates';

function prepareImage(image) {
  const clonedImage = image.cloneNode(true);
  clonedImage.loading = 'eager';
  clonedImage.decoding = 'async';
  clonedImage.removeAttribute('fetchpriority');
  return clonedImage;
}

function buildStaticImageMenu(source) {
  const cards = source.querySelectorAll('.dd-mega-menu-card');
  if (!cards.length) return null;

  const wrapper = document.createElement('div');
  wrapper.className = 'dd-mobile-menu__image-cards';

  cards.forEach((card) => {
    const isLink = card.matches('a[href]');
    const mobileCard = document.createElement(isLink ? 'a' : 'div');
    mobileCard.className = 'dd-mobile-menu__image-card';

    if (isLink) mobileCard.href = card.getAttribute('href');

    const image = card.querySelector('img');
    if (image) mobileCard.append(prepareImage(image));

    const title = card.querySelector('.dd-mega-menu-card__title');
    if (title?.textContent.trim()) {
      const titleElement = document.createElement('span');
      titleElement.textContent = title.textContent.trim();
      mobileCard.append(titleElement);
    }

    if (mobileCard.children.length) wrapper.append(mobileCard);
  });

  return wrapper.children.length ? wrapper : null;
}

function buildColumnMenu(source) {
  const groups = source.querySelectorAll('.dd-column-mega-menu__group');
  if (!groups.length) return null;

  const wrapper = document.createElement('div');
  wrapper.className = 'dd-mobile-menu__columns';

  groups.forEach((group) => {
    const card = document.createElement('article');
    card.className = 'dd-mobile-menu__column-card';

    const sourceMedia = group.querySelector('.dd-column-mega-menu__media');
    if (sourceMedia) {
      const media = sourceMedia.cloneNode(false);
      media.className = 'dd-mobile-menu__media';
      const image = sourceMedia.querySelector('img');
      if (image) media.append(prepareImage(image));
      card.append(media);
    }

    const sourceHeadingLink = group.querySelector('.dd-column-mega-menu__heading-link');
    if (sourceHeadingLink) {
      const heading = document.createElement('h3');
      heading.append(sourceHeadingLink.cloneNode(true));
      card.append(heading);
    }

    const sourceLinks = group.querySelector('.dd-column-mega-menu__links');
    if (sourceLinks) {
      const links = sourceLinks.cloneNode(true);
      links.className = 'dd-mobile-menu__sub-links';
      card.append(links);
    }

    if (card.children.length) wrapper.append(card);
  });

  return wrapper.children.length ? wrapper : null;
}

function buildProductMenu(source) {
  const categories = source.querySelectorAll('[data-dd-product-category-source]');
  if (!categories.length) return null;

  const wrapper = document.createElement('div');
  wrapper.className = 'dd-mobile-menu__product-categories';

  categories.forEach((category) => {
    const sourceTrigger = category.querySelector('[data-dd-product-category-trigger]');
    if (!sourceTrigger) return;

    const card = document.createElement('a');
    card.className = 'dd-mobile-menu__product-category';
    card.href = sourceTrigger.getAttribute('href') || '#';

    const sourceImage = category.querySelector('.dd-product-mega-menu__product-card img');
    if (sourceImage) {
      card.append(prepareImage(sourceImage));
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'dd-mobile-menu__product-placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      card.append(placeholder);
    }

    const title = document.createElement('span');
    title.textContent = sourceTrigger.textContent.trim();
    card.append(title);
    wrapper.append(card);
  });

  return wrapper.children.length ? wrapper : null;
}

function buildMobileContent(template) {
  const source = template.content;

  if (source.querySelector('.dd-mega-menu')) return buildStaticImageMenu(source);
  if (source.querySelector('.dd-column-mega-menu')) return buildColumnMenu(source);
  if (source.querySelector('.dd-product-mega-menu')) return buildProductMenu(source);

  return null;
}

function findTemplateContainer(menu) {
  const header = menu.closest('header-component');
  return header?.querySelector(TEMPLATE_CONTAINER_SELECTOR) || document.querySelector(TEMPLATE_CONTAINER_SELECTOR);
}

function hydrateMobileMenu(menu) {
  if (!(menu instanceof HTMLElement)) return;

  const sources = findTemplateContainer(menu);
  if (!sources) return;

  const templates = new Map();
  sources.querySelectorAll('template[data-dd-mega-menu]').forEach((template) => {
    const trigger = template.dataset.menuTrigger?.trim().toLowerCase();
    if (trigger && !templates.has(trigger)) templates.set(trigger, template);
  });

  menu.querySelectorAll('[data-dd-mobile-menu-trigger]').forEach((details) => {
    if (details.dataset.ddMobileMenuHydrated === 'true') return;

    const trigger = details.dataset.ddMobileMenuTrigger?.trim().toLowerCase();
    const panel = details.querySelector('[data-dd-mobile-menu-panel]');
    const template = templates.get(trigger);
    if (!panel || !template) return;

    const content = buildMobileContent(template);
    if (!content) return;

    panel.replaceChildren(content);
    details.dataset.ddMobileMenuHydrated = 'true';
  });
}

function hydrateAllMobileMenus(root = document) {
  if (root instanceof Element && root.matches(MOBILE_MENU_SELECTOR)) {
    hydrateMobileMenu(root);
  }

  root.querySelectorAll?.(MOBILE_MENU_SELECTOR).forEach(hydrateMobileMenu);
}

let hydrationQueued = false;
function queueHydration() {
  if (hydrationQueued) return;
  hydrationQueued = true;

  requestAnimationFrame(() => {
    hydrationQueued = false;
    hydrateAllMobileMenus();
  });
}

hydrateAllMobileMenus();

new MutationObserver(queueHydration).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
